import { C, S } from '../constants';
import { fmt, fmtUAH, exportXlsx } from '../utils';
import Img from '../components/Img';
import ProdLink from '../components/ProdLink';
import InfoTip from '../components/InfoTip';
import { Badge, FfBadge } from '../components/badges';

export default function ProblemsPage({ realDead, loss, ffBypass = [], deadCatFilter, setDeadCatFilter, deadSort, setDeadSort, negativeReviews = [] }) {
  const deadCats = ["all", ...Array.from(new Set(realDead.map(p => p.category_name || "Без категорії"))).sort()];
  const filteredDead = realDead
    .filter(p => deadCatFilter === "all" || (p.category_name || "Без категорії") === deadCatFilter)
    .slice().sort((a, b) => {
      if (deadSort === "days_desc") return (b.days_without_sale === 9999 ? 99999 : b.days_without_sale) - (a.days_without_sale === 9999 ? 99999 : a.days_without_sale);
      if (deadSort === "days_asc") return (a.days_without_sale === 9999 ? 99999 : a.days_without_sale) - (b.days_without_sale === 9999 ? 99999 : b.days_without_sale);
      return (b.stock || 0) - (a.stock || 0);
    });

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
        <div style={{ fontSize: 20, fontWeight: 800 }}>Проблеми</div>
        <div onClick={() => {
          const sheets = [];
          if (realDead?.length) {
            const rows = [["ID", "Назва", "Артикул", "Категорія", "Залишок", "Днів без продажу", "FF?"]];
            realDead.forEach(p => rows.push([p.product_id, p.name || "", p.article || "", p.category_name || "", p.stock || 0, p.days_without_sale === 9999 ? "Ніколи" : p.days_without_sale, p.is_ff ? "FF" : "FBS"]));
            sheets.push({ name: "Мертвий запас", rows });
          }
          if (ffBypass?.length) {
            const rows = [["ID", "Назва", "Артикул", "FF залишок", "FBS продажів за 14д"]];
            ffBypass.forEach(p => rows.push([p.product_id, p.name || "", p.article || "", p.ff_stock || 0, p.fbs_orders_14d || 0]));
            sheets.push({ name: "FF байпас", rows });
          }
          if (negativeReviews?.length) {
            const rows = [["ID", "Назва", "Артикул", "Рейтинг", "К-ть відгуків", "Останній відгук"]];
            negativeReviews.forEach(p => rows.push([p.product_id, p.name || "", p.article || "", p.agg_rating || "", p.review_count || 0, p.top_rating ?? ""]));
            sheets.push({ name: "Негативні відгуки", rows });
          }
          if (loss?.length) {
            const rows = [["ID", "Назва", "Артикул", "Прибуток/шт", "Маржа%", "Ціна", "Собівартість"]];
            loss.forEach(p => rows.push([p.product_id, p.name || "", p.article || "", p.profit_per_unit || 0, p.margin_pct || 0, p.avg_price || 0, p.cost_price || 0]));
            sheets.push({ name: "Збиткові", rows });
          }
          if (sheets.length) exportXlsx(sheets, "проблеми.xlsx");
        }} style={{
          padding: "7px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600,
          cursor: "pointer", userSelect: "none",
          background: `${C.green}18`, color: C.green,
          border: `1px solid ${C.green}40`,
        }}>
          ↓ Excel
        </div>
      </div>

      {/* FF Bypass Warning */}
      {ffBypass.length > 0 && (
        <div style={{ ...S.card, marginBottom: 16, border: `1px solid ${C.yellow}44` }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: C.yellow, marginBottom: 4, display: "flex", alignItems: "center", gap: 8 }}>
            ⚡ Відправка FBS при наявному FF складі — {ffBypass.length} SKU
            <InfoTip text={"Ці товари мають реальний залишок на складі Rozetka (FF), але за останні 14 днів замовлення по ним оброблялись як FBS (ви відправляли самостійно).\n\nМожливо ви тимчасово зняли товар з FF (наприклад для самозакупу/розкрутки) і забули повернути. Перевірте налаштування в кабінеті Rozetka."} />
          </div>
          <div style={{ fontSize: 12, color: C.text3, marginBottom: 12 }}>
            Rozetka може автоматично відправити замовлення з FF складу — переконайтесь що налаштування правильні
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 10 }}>
            {ffBypass.map(p => (
              <div key={p.product_id} style={{
                background: C.bg1, border: `1px solid ${C.yellow}33`,
                borderRadius: 10, padding: 12, display: "flex", gap: 10
              }}>
                <Img src={p.image_url} size={40} />
                <div style={{ minWidth: 0, flex: 1 }}>
                  <ProdLink name={p.name} article={p.article} productId={p.product_id} style={{ fontSize: 12 }} />
                  <div style={{ marginTop: 5, display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <span style={{ fontSize: 11, background: `${C.green}22`, color: C.green,
                      padding: "2px 8px", borderRadius: 6, fontWeight: 700 }}>
                      FF склад: {p.ff_stock} шт.
                    </span>
                    <span style={{ fontSize: 11, background: `${C.yellow}22`, color: C.yellow,
                      padding: "2px 8px", borderRadius: 6 }}>
                      FBS відправлено: {p.fbs_qty_2weeks} шт. за 2 тижні
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <div style={{ ...S.card, marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 10, marginBottom: 14 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: C.yellow, display: "flex", alignItems: "center", gap: 8 }}>
            💤 Мертвий запас — {filteredDead.length} / {realDead.length} SKU
            <InfoTip text={"Товари з наявністю на складі, які не мали жодного продажу протягом 7+ днів.\nЦе заморожені гроші — рекомендується знижка або виведення з асортименту."} />
          </div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
            {[["Дні ↓", "days_desc"], ["Дні ↑", "days_asc"], ["Запас ↓", "stock_desc"]].map(([l, v]) => (
              <div key={v} onClick={() => setDeadSort(v)} style={S.btn(deadSort === v, C.blue)}>{l}</div>
            ))}
          </div>
        </div>
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 12 }}>
          {deadCats.map(cat => (
            <div key={cat} onClick={() => setDeadCatFilter(cat)}
              style={S.btn(deadCatFilter === cat, C.yellow)}>
              {cat === "all" ? "Всі категорії" : cat}
            </div>
          ))}
        </div>
        {filteredDead.length === 0
          ? <div style={{ color: C.text3 }}>Мертвого запасу немає 🎉</div>
          : (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 10 }}>
              {filteredDead.map((p) => (
                <div key={p.product_id} style={{ background: C.bg1, border: `1px solid ${C.border}`,
                  borderRadius: 10, padding: 12, display: "flex", gap: 10, minWidth: 0, overflow: "hidden" }}>
                  <Img src={p.image_url} size={40} />
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <ProdLink name={p.name} article={p.article} productId={p.product_id} style={{ fontSize: 12 }} />
                    <div style={{ fontSize: 11, color: C.text3, marginTop: 3 }}>
                      {p.stock} шт.
                    </div>
                    {p.never_sold
                      ? <Badge color={C.pink}>Не продавався</Badge>
                      : <Badge color={p.days_without_sale >= 9999 ? C.pink : p.days_without_sale > 30 ? C.pink : C.yellow}>
                          {p.days_without_sale >= 9999 ? "ніколи" : `${p.days_without_sale}д без продажу`}
                        </Badge>
                    }
                  </div>
                </div>
              ))}
            </div>
          )
        }
      </div>

      {/* Negative reviews section */}
      {negativeReviews.length > 0 && (
        <div style={{ ...S.card, marginBottom: 16, border: `1px solid #f8717144` }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#f87171", marginBottom: 4, display: "flex", alignItems: "center", gap: 8 }}>
            ★ Негативний відгук зверху — {negativeReviews.length} SKU
            <InfoTip text={"Товари, у яких перший відгук на сторінці має ≤3★ або взагалі без зірок (заблокований).\nЦе перше що бачить покупець — рекомендується замовити нові відгуки щоб відсунути негатив."} />
          </div>
          <div style={{ fontSize: 12, color: C.text3, marginBottom: 12 }}>
            Перший відгук визначає враження покупця — варто отримати нові позитивні відгуки
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 10 }}>
            {negativeReviews.map(({ product, review }) => {
              const topBad = review.top_rating === null || review.top_rating === undefined || review.top_rating <= 3;
              const stars = n => n ? '★'.repeat(n) + '☆'.repeat(5 - n) : null;
              return (
                <div key={product.product_id} style={{
                  background: C.bg1, border: "1px solid rgba(248,113,113,0.2)",
                  borderRadius: 10, padding: 12, display: "flex", gap: 10
                }}>
                  <Img src={product.image_url} size={40} />
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <ProdLink name={product.name} article={product.article} productId={product.product_id} style={{ fontSize: 12 }} />
                    <div style={{ marginTop: 5, display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                      <span style={{ fontSize: 12, fontWeight: 700, color: C.text2 }}>
                        ★ {review.agg_rating?.toFixed(1) ?? "—"}
                        <span style={{ fontSize: 10, fontWeight: 400, color: C.text4, marginLeft: 3 }}>({review.review_count ?? 0})</span>
                      </span>
                      <span style={{ fontSize: 11, background: "rgba(248,113,113,0.15)", color: "#f87171",
                        padding: "2px 8px", borderRadius: 6, fontWeight: 700 }}>
                        {topBad && (review.top_rating === null || review.top_rating === undefined)
                          ? "⚠ без зірок"
                          : `остання: ${stars(review.top_rating)}`}
                      </span>
                      <a href={`https://rozetka.com.ua/ua/x/p${product.rozetka_id}/comments/`}
                        target="_blank" rel="noreferrer"
                        style={{ fontSize: 11, color: C.blue, textDecoration: "none" }}>
                        відгуки →
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div style={S.card}>
        <div style={{ fontSize: 15, fontWeight: 700, color: C.pink, marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
          ❌ Продаж у мінус — {loss.length} SKU
          <InfoTip text={"Товари, де ПОТОЧНА ціна мінус комісія, 3% платіжки, доставка і собівартість дає від'ємний результат.\nЯкщо підняли ціну — товар зникне зі списку після наступного синку каталогу.\n\nСередня ціна фактичних продажів за обраний період показана довідково.\n\nКлікніть на назву — відкриє товар на Rozetka."} />
        </div>
        {loss.length === 0
          ? <div style={{ color: C.text3 }}>Збиткових немає (або не введена собівартість)</div>
          : (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 12 }}>
              {loss.map((p, i) => (
                <div key={i} style={{ background: C.bg1, border: "1px solid rgba(244,114,182,.2)",
                  borderRadius: 10, padding: 14, minWidth: 0, overflow: "hidden" }}>
                  <div style={{ display: "flex", gap: 10, marginBottom: 10, minWidth: 0 }}>
                    <Img src={p.image_url} size={42} />
                    <div style={{ minWidth: 0, flex: 1 }}>
                      <ProdLink name={p.name} article={p.article} productId={p.product_id} style={{ fontSize: 13 }} />
                      <div style={{ fontSize: 11, color: C.text3, marginTop: 2 }}>ID: {p.product_id}</div>
                      <FfBadge isFf={p.is_ff} />
                    </div>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 4, fontSize: 12 }}>
                    {[
                      ["Ціна зараз", fmtUAH(p.catalog_price), C.text1],
                      [`Комісія ${p.commission_pct}%`, `-${fmtUAH(p.commission_amt)}`, C.yellow],
                      ["3% платіжки", `-${fmtUAH(p.payment_fee)}`, C.yellow],
                      ["Доставка", `-${fmtUAH(p.delivery_cost_used)}`, C.purple],
                      ["Собівартість", `-${fmtUAH(p.cost_price)}`, C.text2],
                      ["Збиток/шт", fmtUAH(p.profit_per_unit), C.pink],
                      ["Збиток всього", fmtUAH(p.profit_total), C.pink],
                      ["Продано шт.", String(p.quantity), C.text2],
                    ].flatMap(([l, v, c]) => [
                      <div key={l} style={{ color: C.text3 }}>{l}</div>,
                      <div key={l+"v"} style={{ color: c, fontWeight: 700, textAlign: "right" }}>{v}</div>,
                    ])}
                  </div>
                  {Math.abs(p.catalog_price - p.avg_price) > 5 && (
                    <div style={{ marginTop: 8, padding: "5px 10px",
                      background: "rgba(148,163,184,.08)", borderRadius: 6, fontSize: 11, color: C.text3 }}>
                      Ціна продажів за період: {fmtUAH(p.avg_price)}
                      {p.avg_profit_unit != null && (
                        <span style={{ marginLeft: 6, color: p.avg_profit_unit >= 0 ? C.green : C.pink }}>
                          → {fmtUAH(p.avg_profit_unit)}/шт
                        </span>
                      )}
                    </div>
                  )}
                  {p.promo_count > 0 && p.avg_regular_price > p.avg_price + 1 && (
                    <div style={{ marginTop: 4, padding: "5px 10px",
                      background: "rgba(244,114,182,.1)", borderRadius: 6, fontSize: 11, color: "#f9a8d4" }}>
                      ⚠ {p.promo_count} шт. за промо {fmtUAH(p.avg_price)} (зв. {fmtUAH(p.avg_regular_price)})
                    </div>
                  )}
                </div>
              ))}
            </div>
          )
        }
      </div>
    </div>
  );
}
